import { render, staticRenderFns } from "./LoteProducaoCO2Grafico.vue?vue&type=template&id=68419fbe&"
import script from "./LoteProducaoCO2Grafico.vue?vue&type=script&lang=js&"
export * from "./LoteProducaoCO2Grafico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports